import { render, staticRenderFns } from "./SkinSuccessScreen.vue?vue&type=template&id=cab3d29a&scoped=true"
import script from "./SkinSuccessScreen.vue?vue&type=script&lang=js"
export * from "./SkinSuccessScreen.vue?vue&type=script&lang=js"
import style0 from "./SkinSuccessScreen.vue?vue&type=style&index=0&id=cab3d29a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab3d29a",
  null
  
)

export default component.exports